import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { ChartContentModel } from 'src/shared/model/chart-content-model';
import { HttpCustomService } from 'src/service/http-custom.service';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';
import { Subscription, Observable } from 'rxjs';
import { CommonConstants, NumberConstants } from 'src/shared/constants/common-constants.enum';

@Component({
  selector: 'dcu-chart-common',
  templateUrl: './chart-common.component.html',
  styleUrls: ['./chart-common.component.scss']
})
export class ChartCommonComponent implements OnInit, OnDestroy {
  chartDatas: ChartDataSets[];
  chartLabels: Label[];
  chartOptions: ChartOptions;
  chartColors: Color[];
  chartLegend = true;
  chartType = 'bar';
  chartPlugins = [];

  @Input() chartContent: ChartContentModel;
  @Input() showFilter = true;
  @Input() id: string;
  @Input() isCustomCancelFilter: boolean;
  @Output() addNewCustomEvent = new EventEmitter();
  @Output() clearValue = new EventEmitter();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onChangeFilterBox = new EventEmitter();
  isLoading = true;
  subscription: Subscription;

  constructor(
    private http: HttpCustomService
  ) { }

  ngOnInit(): void {
    this.getChartData();
    this.subscription = Observable.interval(NumberConstants.TIME_REFRESH).subscribe(
      () => this.getChartData()
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getChartData(): void {
    if (this.chartContent.chartConfig && this.chartContent.chartConfig.chartOptions) {
      this.chartOptions = this.chartContent.chartConfig.chartOptions;
    }
    if (this.chartContent.chartConfig && this.chartContent.chartConfig.chartLegend) {
      this.chartLegend = this.chartContent.chartConfig.chartLegend;
    }
    if (this.chartContent.chartConfig && this.chartContent.chartConfig.chartType) {
      this.chartType = this.chartContent.chartConfig.chartType;
    }
    if (this.chartContent.chartConfig && this.chartContent.chartConfig.chartPlugins) {
      this.chartPlugins = this.chartContent.chartConfig.chartPlugins;
    }
    if (this.chartContent.chartConfig && this.chartContent.chartConfig.chartColors) {
      this.chartColors = this.chartContent.chartConfig.chartColors;
    }
    this.http.get(this.chartContent.chartConfig.urlStateParam, this.chartContent.chartConfig.customParams).pipe(take(1)).subscribe(res => {
      if (res) {
        this.chartDatas = res.chartDatas;
        this.chartLabels = res.chartLabels;
        this.isLoading = false;
      }
    });
  }

  addNewCustom(): void {
    this.addNewCustomEvent.emit();
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
  }

  onClearValue($event): void {
    this.clearValue.emit($event);
  }

  onChangeDataFilter(formValue): void {
    this.onChangeFilterBox.emit(formValue);
  }

  onChangeFilter(paramFilters: any): void {
    if (!this.chartContent.chartConfig.customParams) {
      this.chartContent.chartConfig.customParams = {};
    }
    for (const key of _.keys(paramFilters)) {
      const searchValue = paramFilters[key];
      if (searchValue) {
        this.chartContent.chartConfig.customParams[key] = searchValue;
      } else {
        this.chartContent.chartConfig.customParams[key] = null;
      }
    }
    this.getChartData();
  }

}
